import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Data.LIST_SUCCESS:
      if (action.entityType === 'account/ap' && state === null) {
        const defaultAp = action.payload?.find?.(
          pool => pool.name === 'default',
        )
        return defaultAp?.id || null
      }
      return state
    case ActionType.Tasks.SELECT_ASSIGNMENT_POOL:
      return action.payload
    case ActionType.Tasks.RECEIVE_TASK:
      if (
        typeof action.payload?.reassign_contact?.trigger_data?.assign_to
          ?.assignmentpool_id !== 'undefined'
      ) {
        return (
          action.payload?.reassign_contact?.trigger_data?.assign_to
            ?.assignmentpool_id || null
        )
      }

      if (action.assignmentPools) {
        return (
          Object.values(action.assignmentPools || {})?.find?.(
            pool => pool.name === 'default',
          )?.id || null
        )
      }
      return null
    default:
      return state
  }
}
